module.exports = __webpack_public_path__ + "cd28c420aee621004a11ef8a047cd549.jpg";